export default function preparationItemCategoryUniqueNameDirective(
  $q,
  amSharedModelService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const auditId = attributes.auditId || -1;
    const preparationItemCategoryId = attributes.preparationItemCategoryId || -1;

    ngModel.$asyncValidators.amPreparationItemCategoryUniqueName = modelValue => amSharedModelService
      .checkPreparationItemCategoryExists(auditId, preparationItemCategoryId, modelValue)
      .then((nameExists) => {
        if (!nameExists) {
          return $q.resolve();
        }
        return $q.reject();
      })
      .catch(() => $q.reject());
  }
}

export const name = 'amPreparationItemCategoryUniqueName';

preparationItemCategoryUniqueNameDirective.$inject = [
  '$q',
  'amSharedModelService'
];
